import React, { useState } from 'react';
import { Button, Col, Row, Select } from '@thd-olt-component-react/core-ui';
import { Input } from '@thd-olt-component-react/input';
import { zipCodeRegex } from '@thd-olt-functional/utils';
import PropTypes from 'prop-types';
import {
  IconWithRoundBorder
} from '../IconWithRoundBorder/IconWithRoundBorder';
import constants from '../../constants/constants';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';
import './inputAddressModal.scss';

export const InputAddressModal = ({ handleClose, isMobile, handleContinue }) => {

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [city, setCity] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [zip5, setZip5] = useState('');

  const handleContinueClick = () => {
    handleContinue({
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      state: selectedState.substring(0, 2),
      city,
      zip5,
      standardized: false,
    });
  };

  const handleSelect = (stateList) => {
    setSelectedState(stateList.target.value);
  };

  const validateZipCode = (fieldValue) => {
    return zipCodeRegex.test(fieldValue);
  };

  const validateInput = (fieldValue) => {
    return fieldValue.length > 0;
  };

  const isEnabled = firstName.length > 0
    && lastName.length > 0
    && addressLine1.length > 0
    && city.length > 0
    && selectedState.length > 0
    && validateZipCode(zip5);

  const handleZip5Change = (event) => {
    if (event.key.length === 1 && /\D/.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={handleClose}
      open
    >
      <Row className="preferences-modal__content">
        <Col>
          <Row>
            <Col className="modal-title modal-title--with-round-icon">
              {!isMobile && (
                <IconWithRoundBorder
                  iconSrc="https://assets.homedepot-static.com/images/v1/mailbox.svg"
                  iconWidth="27.7px"
                />
              )}
              <h1>Remove From Mailing List</h1>
            </Col>
            <Col className="text">
              <h3>
                To be removed from The Home Depot mailing list, please provide your mailing information below.
                Please make sure all required information is correctly entered. When finished, click “Continue.”
              </h3>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input
                header="First Name"
                type="text"
                name="firstName"
                defaultValue={firstName}
                value={firstName}
                validation={validateInput}
                onChange={setFirstName}
                validateOnBlur
              />
            </Col>
            <Col md={6}>
              <Input
                header="Last Name"
                type="text"
                name="lastName"
                defaultValue={lastName}
                value={lastName}
                validation={validateInput}
                onChange={setLastName}
                validateOnBlur
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input
                header="Street Name"
                type="text"
                name="street"
                defaultValue={addressLine1}
                value={addressLine1}
                validation={validateInput}
                onChange={setAddressLine1}
                validateOnBlur
              />
            </Col>
            <Col md={6}>
              <Input
                header="Unit, Apartment Number, Building Number, etc."
                type="text"
                name="apartment"
                defaultValue={addressLine2}
                value={addressLine2}
                validation={validateInput}
                onChange={setAddressLine2}
                validateOnBlur
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Input
                header="City"
                type="text"
                name="city"
                defaultValue={city}
                value={city}
                validation={validateInput}
                onChange={setCity}
                validateOnBlur
              />
            </Col>
            <Col md={6}>
              <Select
                header="State"
                selected={selectedState}
                options={constants.STATES}
                onChange={handleSelect}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Input
                maxLength="5"
                header="Zip Code"
                type="text"
                name="zipcode"
                defaultValue={zip5}
                errorText="Please enter a valid 5-digit ZIP Code."
                value={zip5}
                validation={validateZipCode}
                onChange={setZip5}
                onKeyPress={handleZip5Change}
                validateOnBlur
              />
            </Col>
          </Row>
          <hr className="hr-line" />
          <Row style={{ marginTop: '10px' }}>
            <Col nopadding lg={9} />
            <Col lg={3}>
              <Button
                data-testid="postalUnsubContinueButton"
                onClick={handleContinueClick}
                disabled={!isEnabled}
              >
                Continue
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </MobileAwareOverlay>
  );
};

InputAddressModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  handleContinue: PropTypes.func.isRequired,
};

InputAddressModal.defaultProps = {
  isMobile: false,
};
